import {
  fetchRejectionsCard,
  fetchRejectionsTableAndChart,
  fetchRejectionSourceVisual,
  fetchRejectionStageVisual,
  fetchRejectedReasonVisual,
  fetchRejectionDrilldown,
} from './actions';
import { getDefaultAtsFilters, buildReportsSlice } from '../common/ats-filters';
import { flatTransformer, getTableData } from '../common/flat-transformer';
import { cardTransformer } from '../common/card-transformer';
import { visualPayload } from '../common/visual-transformer';
import { getPercentage } from '../common/get-percentage';

const getChartData = (response) => {
  const {
    chart = [],
    headers,
    lookups: { dt, g1, g2 } = {},
  } = response?.data || {};
  return flatTransformer({ headers, datas: chart, g1, g2, dt });
};

const tableWithTotal = (data) => {
  const rejections_total = data?.reduce(
    (acc, curr) => acc + curr?.rejections,
    0
  );
  function innerFunc(data) {
    if (!data?.length) return [];
    return data.map((datum) => {
      return {
        ...datum,

        rejections_total,
        rejections_per: getPercentage(datum?.rejections, rejections_total),
        subRows: innerFunc(datum?.subRows),
      };
    });
  }

  return innerFunc(data);
};

const constructDrilldownData = (payload) => {
  const k1Map = payload?.data?.lookups?.k1;
  const k2Map = payload?.data?.lookups?.k2;
  const k3Map = payload?.data?.lookups?.k3;
  const k4Map = payload?.data?.lookups?.k4;
  const k5Map = payload?.data?.lookups?.k5;
  const k6Map = payload?.data?.lookups?.k6;
  const k7Map = payload?.data?.lookups?.k7;
  const k8Map = payload?.data?.lookups?.k8;
  const k9Map = payload?.data?.lookups?.k9;
  const k10Map = payload?.data?.lookups?.k10;
  const returnData = payload?.data?.table?.map((data) => {
    // eslint-disable-next-line no-unused-vars
    const [, k1, k2, k3, k4, k5, k6, k7, k8, k9, k10, time_to_reject,rejected_by_type_value] = data;
    return {
      ...k1Map?.[k1],
      rejection_type: k2Map?.[k2],
      rejection_reason: k3Map?.[k3],
      source: k4Map?.[k4],
      credited_to: k5Map?.[k5],
      rejected_by: k6Map?.[k6],
      job: k7Map?.[k7],
      rejection_stage: k8Map?.[k8],
      department: k9Map?.[k9],
      office_names: k10Map?.[k10],
      time_to_reject,
			rejected_by_type_value
    };
  });

  return returnData;
};

const initialState = {
  ...getDefaultAtsFilters(),

  isCardLoading: false,
  cards: {},

  chart: [],
  table: [],
  isChartLoading: false,
  isTableLoading: false,

  rejectedReasons: [],
  isRejectedReasonsLoading: false,

  rejectionSources: [],
  isRejectionSourcesLoading: false,
  rejectionStage: [],
  isRejectionStageLoading: false,
  isDrillLoading: false,
  initialLoading: false,
  drilldownData: [],
  stageMapping: {},
  totalCount: 0,
  currentDrillPage: 1,
};

const extraReducers = {
  [fetchRejectionsCard.pending]: (state) => {
    state.isCardLoading = true;
  },
  [fetchRejectionsCard.fulfilled]: (state, { payload }) => {
    state.cards = cardTransformer(payload);
    state.isCardLoading = false;
  },
  [fetchRejectionsCard.rejected]: (state) => {
    state.isCardLoading = false;
  },

  [fetchRejectionsTableAndChart.pending]: (state) => {
    state.isChartLoading = true;
    state.isTableLoading = true;
  },

  [fetchRejectionsTableAndChart.fulfilled]: (state, { meta, payload = {} }) => {
    state.isChartLoading = false;
    state.isTableLoading = false;
    state.chart = getChartData(payload);
    state.table = tableWithTotal(getTableData(payload, meta?.arg));
  },

  [fetchRejectionsTableAndChart.rejected]: (state) => {
    state.isChartLoading = false;
    state.isTableLoading = false;
  },

  [fetchRejectedReasonVisual.pending]: (state) => {
    state.isRejectedReasonsLoading = true;
  },

  [fetchRejectedReasonVisual.fulfilled]: (state, { payload = {} }) => {
    state.rejectedReasons = getTableData(payload);
    state.isRejectedReasonsLoading = false;
  },

  [fetchRejectedReasonVisual.rejected]: (state) => {
    state.isRejectedReasonsLoading = false;
  },

  [fetchRejectionStageVisual.pending]: (state) => {
    state.isRejectionStageLoading = true;
  },
  [fetchRejectionStageVisual.fulfilled]: (state, { payload }) => {
    state.rejectionStage = visualPayload(payload);
    state.isRejectionStageLoading = false;
  },
  [fetchRejectionStageVisual.rejected]: (state) => {
    state.isRejectionStageLoading = false;
  },

  [fetchRejectionSourceVisual.pending]: (state) => {
    state.isRejectionSourcesLoading = true;
  },
  [fetchRejectionSourceVisual.fulfilled]: (state, { payload }) => {
    state.rejectionSources = visualPayload(payload);
    state.isRejectionSourcesLoading = false;
  },
  [fetchRejectionSourceVisual.rejected]: (state) => {
    state.isRejectionSourcesLoading = false;
  },
  [fetchRejectionDrilldown.pending]: (state, { meta }) => {
    const { drilldown } = meta?.arg || {};
    if (drilldown.page === 1) {
      state.initialLoading = true;
    } else {
      state.isDrillLoading = true;
    }
  },
  [fetchRejectionDrilldown.fulfilled]: (state, { meta, payload = {} }) => {
    if (!payload) {
      return;
    }
    state.isDrillLoading = false;
    state.initialLoading = false;

    const { drilldown } = meta?.arg || {};
    const newData = constructDrilldownData(payload);
    state.totalCount = payload?.data?.pagination?.total_count;
    if (drilldown.page === 1) {
      state.drilldownData = newData;
    } else {
      state.drilldownData = [...state.drilldownData, ...newData];
    }
    state.currentDrillPage = drilldown.page;
  },
  [fetchRejectionDrilldown.rejected]: (state, action) => {
    if (
      action.error?.name === 'AbortError' ||
      action.error?.name === 'CanceledError'
    ) {
      return;
    }
    state.isDrillLoading = false;
    state.initialLoading = false;
  },
};

export const { reducer, actions } = buildReportsSlice({
  name: 'atsRejectionsReport',
  initialState,
  extraReducers,
});

export const {
  applyFilter,
  resetFilter,
  applyTimeFrame,
  applyViewBy,
  applyGroup,
  setFiltersData,
  applySearch,
  resetDrillDown,
} = actions;
export default reducer;
